/**
 * format.ts — tiny shared UI formatting helpers (HUD + menu screens).
 */

/** 1 → "1st", 2 → "2nd", 3 → "3rd", n → "nth". */
export function ordinal(n: number): string {
  if (n === 1) return '1st';
  if (n === 2) return '2nd';
  if (n === 3) return '3rd';
  return `${n}th`;
}

/** A race time in ms → "m:ss.t" (e.g. 92500 → "1:32.5"). */
export function fmtRaceTime(ms: number): string {
  const total = Math.max(0, ms) / 1000;
  const m = Math.floor(total / 60);
  const s = total - m * 60;
  const whole = Math.floor(s);
  const tenth = Math.floor((s - whole) * 10);
  return `${m}:${String(whole).padStart(2, '0')}.${tenth}`;
}

/** three.js hex colour number → CSS "#rrggbb". */
export function cssColor(color: number): string {
  return `#${color.toString(16).padStart(6, '0')}`;
}
